import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import Dropdown, {alignConstants, sizeConstants} from '../Dropdown/Dropdown';
import chat from '../../utils/chat';

import styles from './AccountManagerLink-style.scss';

export class AccountManagerLink extends React.Component {
    constructor(props) {
        super(props);

        this.handleChatClick = this.handleChatClick.bind(this);
    }

    handleChatClick(e) {
        e.preventDefault();
        chat.show();
    }

    render() {
        return (
            <Dropdown
                align={alignConstants.ALIGN_CENTER}
                size={sizeConstants.SIZE_SMALL}
                className={styles.wrapper}
            >
                <div className={styles.link}>
                    <FormattedMessage
                        id='dbl.Header.AccountManagerLink.label'
                        defaultMessage='Trade Concierge'
                    />
                </div>
                <div className={styles.sectionWrapper}>
                    <div className={styles.section}>
                        <div className={styles.title}>
                            <FormattedMessage
                                id='dbl.Header.AccountManagerLink.contact_title'
                                defaultMessage='For direct access to our trade concierge specialists, contact:'
                            />
                        </div>
                        <div className={styles.copy}>
                            <FormattedMessage
                                id='dbl.Header.AccountManagerLink.contact_phone_number'
                                defaultMessage='{phoneNumber} or'
                                values={{phoneNumber: "+1 646 454 2651"}}
                                tagName='div'
                            />
                            <FormattedMessage
                                id='dbl.Header.AccountManagerLink.contact_toll_free'
                                defaultMessage='toll free: {phoneNumber}'
                                values={{phoneNumber: "+1 877 721 3427"}}
                                tagName='div'
                            />
                            <FormattedMessage
                                id='dbl.Header.AccountManagerLink.contact_email'
                                defaultMessage='trade@1stdibs.com'
                                tagName='div'
                            />
                        </div>
                        <a className={styles.cta} onClick={this.handleChatClick}>
                            <FormattedMessage
                                id='dbl.Header.AccountManagerLink.contact_chat'
                                defaultMessage='Chat Now'
                            />
                        </a>
                    </div>
                </div>
                <div className={classnames(styles.sectionWrapper, styles.separator)}>
                    <div className={styles.section}>
                        <div className={styles.title}>
                            <FormattedMessage
                                id='dbl.Header.AccountManagerLink.sourcing_title'
                                defaultMessage='Free Sourcing for Designers'
                            />
                        </div>
                        <div className={styles.copy}>
                            <FormattedMessage
                                id='dbl.Header.AccountManagerLink.sourcing_content'
                                defaultMessage='Let our team of experts find what you need for your project.'
                            />
                        </div>
                        <a className={styles.cta} href="/trade/sourcing/">
                            <FormattedMessage
                                id='dbl.Header.AccountManagerLink.sourcing_cta'
                                defaultMessage='Learn more'
                            />
                        </a>
                    </div>
                </div>
            </Dropdown>
        );
    }
}

export default AccountManagerLink;



// WEBPACK FOOTER //
// ./src/components/AccountManagerLink/AccountManagerLink.jsx